import React from 'react';
import TeamCandidateScopeProvider from "./TeamCandidateScopeProvider";
import ManageTeamScopeTable from "./ManageTeamScopeTable";
import {useProject} from "../../../providers/ClientProjectProvider";

const ManageTeamScopeLayout = () => {
    const {
        project,
        isProjectUpdating
    } = useProject()
    return (
        <TeamCandidateScopeProvider project={project} isDisabled={isProjectUpdating}>
            <ManageTeamScopeTable/>
        </TeamCandidateScopeProvider>
    );
};

export default ManageTeamScopeLayout;